import { takeLatest } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { PARSE_FILES_ACTIONS } from "./actionTypes";
import { ParseFilesApi } from "./api";
/**
 * Upload file for parsing
 *
 * @param {SearchQuery} searchQuery
 *
 * @return {Generator}
 */

function* upload(searchQuery) {
  yield SagasHelper.action(searchQuery, ParseFilesApi.upload);
}

export default [takeLatest(PARSE_FILES_ACTIONS.UPLOAD, upload)];